import { Routes } from '@angular/router';
import { ShellComponent } from './layout/shell.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./features/callback/callback.page').then((m) => m.CallbackPage),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'usuarios',
        loadComponent: () =>
          import('./features/users/users.page').then((m) => m.UsersPage),
      },
      {
        path: 'clientes',
        loadComponent: () =>
          import('./features/client-scope/client-scope.page').then((m) => m.ClientScopePage),
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./features/roles/roles.page').then((m) => m.RolesPage),
      },
      {
        path: 'permisos',
        loadComponent: () =>
          import('./features/permissions/permissions.page').then((m) => m.PermissionsPage),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
